import { Injectable } from "@angular/core";
import { FormSearchParametersModel } from "apps-module/app/entry-modules/venues-search/models/form-search-parameters.model";
import { QuerySearchParametersModel } from "apps-module/app/entry-modules/venues-search/models/query-search-parameters.model";
import { BrowserWindowService } from "apps-module/app/shared-library/services/environment/browser-window.service";
import { QueryStringSerializationService } from "apps-module/app/shared-library/services/environment/query-string-serialization.service";

@Injectable()
export class QuerySearchParametersService {

    public constructor(
        private readonly _serializationService: QueryStringSerializationService,
        private readonly _browserWindowService: BrowserWindowService
    ) {
    }

    public set(searchParameters: FormSearchParametersModel): void {
        const queryParams = {
            pageNumber: searchParameters.pageNumber,
            maxCapacity: searchParameters.maxCapacity,
            minCapacity: searchParameters.minCapacity,
            facilities: searchParameters.facilities,
            location: searchParameters.location,
            searchText: searchParameters.searchText
        } as QuerySearchParametersModel;

        const queryString = this._serializationService.serialize(queryParams);

        this._browserWindowService.setQueryString(queryString);
    }
}
